// Load common dependencies
import "common/sidenav/sidenav.js";
import "common/image-viewer/image-viewer.js";

// Load page specific code
import "pages/featured-scrolls/featured-scrolls.js";

// Load styles.
import "./featured-scrolls.scss";



// WEBPACK FOOTER //
// ./src/frontend/entry-points/featured-scrolls/featured-scrolls.js